var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('KonvaCampaignImage',{attrs:{"config":_vm.konvaImageConfig,"src":_vm.image},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }